import { useNavigate } from 'react-router-dom';

export default function PrivacyNotice() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a1a', padding: '5rem 1.5rem 4rem', color: '#cbd5e1' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', color: '#818cf8', fontSize: 13, cursor: 'pointer', padding: 0, marginBottom: '2rem', display: 'inline-block' }}
        >← Back</button>

        <h1 style={{ color: '#f8fafc', fontSize: 30, fontWeight: 800, margin: '0 0 0.5rem' }}>Privacy Notice</h1>
        <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 2.5rem' }}>Last updated: April 2026 · app.privacy.education</p>

        {[
          {
            title: '1. Who we are',
            body: 'privacy.education is an interactive privacy literacy platform. This notice applies to app.privacy.education — the enterprise product used by organisations to train their teams on privacy and data protection.',
          },
          {
            title: '2. What we collect',
            body: `When you use the enterprise platform we collect:
• Email address, first name, and last name (provided by your organisation administrator at invitation)
• Assessment results: scores, answers, and completion timestamps for Tabletop, Privacy Engineering, and Privacy by Design assessments
• Organisation membership: org ID, role, status, and activity dates
• Technical metadata: your browser may send standard HTTP headers (user-agent, IP address) to our API — we do not log or store these beyond what AWS API Gateway retains for up to 7 days`,
          },
          {
            title: '3. How we use your data',
            body: `We use your data only to:
• Deliver your organisation's privacy training programme
• Track and report your assessment scores and completion within your organisation
• Allow your organisation administrator to monitor team-wide privacy posture
• Send transactional emails (e.g. account invitation, password reset) via AWS Cognito
We do not use your data for advertising and we do not sell it to third parties.`,
          },
          {
            title: '4. Who controls your data',
            body: 'Your organisation is the data controller for your personal data on this platform. privacy.education acts as a data processor on behalf of your organisation. Refer to your organisation\'s privacy policy for information about how they handle your data.',
          },
          {
            title: '5. Where your data is stored',
            body: 'All data is stored in AWS infrastructure located in Canada (ca-central-1 region). Authentication is handled by AWS Cognito (enterprise pool). Assessment results are stored in Amazon DynamoDB. Organisation records are stored in a separate DynamoDB table.',
          },
          {
            title: '6. Data sharing',
            body: `We share data only with the following service providers under contract:
• AWS (Cognito, DynamoDB, API Gateway, S3, CloudFront) — infrastructure
• Your organisation administrator — they can view all assessment results and scores for members of their organisation
We do not share data with any other third parties.`,
          },
          {
            title: '7. Data retention',
            body: 'Your data is retained for the duration of your organisation\'s subscription. Upon termination, data is deleted within 60 days unless a longer retention period is required by law.',
          },
          {
            title: '8. Your rights',
            body: `Depending on your jurisdiction you may have the right to:
• Access a copy of the personal data we hold about you
• Correct inaccurate data
• Request deletion of your data
• Object to or restrict certain processing
Contact your organisation administrator first. For platform-level requests, email privacy@privacy.education`,
          },
          {
            title: '9. Cookies',
            body: 'We do not use tracking or advertising cookies. We store your session token in browser localStorage solely to keep you signed in.',
          },
          {
            title: '10. Changes to this notice',
            body: 'We may update this notice as the platform evolves. Material changes will be communicated via email or an in-app banner.',
          },
          {
            title: '11. Contact',
            body: 'Questions about this notice? Email us at privacy@privacy.education',
          },
        ].map(({ title, body }) => (
          <section key={title} style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#e2e8f0', fontSize: 17, fontWeight: 700, margin: '0 0 0.5rem' }}>{title}</h2>
            <p style={{ fontSize: 14, lineHeight: 1.75, margin: 0, whiteSpace: 'pre-line' }}>{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
